import { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Grid, Typography, Box, InputAdornment, Modal } from "@mui/material";
import TextField from "@mui/material/TextField";
import { formatNumber, formatDate } from "../../Utils/utils";
import ReadOnlySlider from "../ReadOnlySlider";
import { isTestEnv } from "../../globals";

export const BusinessInformation = ({ fnccust }) => {
  const [expandedPanel, setExpandedPanel] = useState(false);
  const handleChange = (event, isExpanded) => {
    setExpandedPanel(isExpanded);
  };

  isTestEnv && console.log("fnccust", fnccust);
  const bdiFields = {
    "אובליגו מומלץ קודם:":
      fnccust?.SRII_BDIOBLIGO2 !== undefined
        ? fnccust?.SRII_BDIOBLIGO2.toLocaleString() +
          " " +
          (fnccust?.CODE === "שח" ? "₪" : fnccust?.CODE)
        : null,
    "דירוג סיכון קודם (0-10):": `${
      fnccust?.SRII_BDIRISK2 !== undefined && fnccust?.SRII_BDIRISK2 !== null
        ? fnccust?.SRII_BDIRISK2
        : ""
    } - ${
      fnccust?.SRII_BDIRISK2DESC !== undefined &&
      fnccust?.SRII_BDIRISK2DESC !== null
        ? fnccust?.SRII_BDIRISK2DESC
        : ""
    }`,
    "דירוג סיכון (0-10):": `${
      fnccust?.SRII_BDIRISK !== undefined && fnccust?.SRII_BDIRISK !== null
        ? fnccust?.SRII_BDIRISK
        : ""
    } - ${
      fnccust?.SRII_BDIRISKDESC !== undefined &&
      fnccust?.SRII_BDIRISKDESC !== null
        ? fnccust?.SRII_BDIRISKDESC
        : ""
    }`,
    "תאריך דירוג סיכון קודם:": fnccust?.SRII_BDIRISKDATE2,
    "תאריך דירוג סיכון:": fnccust?.SRII_BDIRISKDATE,
  };
  const dnbFields = {
    "ציון סקור (0-100):": fnccust?.MED_DNBSCORE,
    "המלצת אשראי:":
      fnccust?.MED_DNBMAXOBLIG !== undefined
        ? fnccust?.MED_DNBMAXOBLIG.toLocaleString()
        : null,
    "תאריך העדכון:":
      fnccust?.MED_DNBSCOREUPDATE !== undefined
        ? formatDate(fnccust?.MED_DNBSCOREUPDATE)
        : null,
    "מספר DUNS:": fnccust?.MED_DNBDUNS,
    'מספר תיק במע"מ:': fnccust?.NEO_VATNUM,
    "תאור מצב כללי:": fnccust?.MED_DNBDUNS,
    "מגמה:": `${
      fnccust?.TRENDCODE !== undefined && fnccust?.TRENDCODE !== null
        ? fnccust?.TRENDCODE
        : ""
    } - ${
      fnccust?.TRENDDES !== undefined && fnccust?.TRENDDES !== null
        ? fnccust?.TRENDDES
        : ""
    }`,
    "תשלום לא פורמלי:": `${
      fnccust?.NEO_PAYCODE !== undefined && fnccust?.NEO_PAYCODE !== null
        ? fnccust?.NEO_PAYCODE
        : ""
    } - ${
      fnccust?.NEO_NONFORMALPAY !== undefined &&
      fnccust?.NEO_NONFORMALPAY !== null
        ? fnccust?.NEO_NONFORMALPAY
        : ""
    }`,
  };

  return (
    <Accordion
      expanded={expandedPanel}
      onChange={handleChange}
      disabled={fnccust === null}
    >
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon />}
        aria-controls="panel-content"
        id="panel-header"
        style={{
          backgroundColor: expandedPanel ? "#f0f0f0" : "inherit",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            // backgroundColor: "#f0f0f0",
            padding: "5px",
            borderRadius: "5px",
          }}
        >
          <span style={{ fontWeight: "bold", fontSize: "1.2rem" }}>
            מידע עסקי
          </span>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <div
              style={{
                marginBottom: "10px",
                marginLeft: "30%",
                marginRight: "5%",
              }}
            >
              <Typography
                style={{
                  // fontWeight: "bold",
                  fontSize: "1.1rem",
                  display: "inline-block",
                  marginBottom: "10px",
                  backgroundColor: "#f0f0f0",
                  padding: "5px",
                  paddingLeft: "4px",
                  paddingRight: "4px",
                  paddingBottom: "3px",
                  paddingTop: "3px",
                  borderRadius: "5px",
                  lineHeight: "1",
                }}
              >
                BDI
              </Typography>
              <div>
                {Object.entries(bdiFields).map(([label, value], index) => (
                  <Box key={index} mb={2}>
                    <TextField
                      label={label}
                      variant="standard"
                      value={value}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        readOnly: true,
                        endAdornment:
                          label === "דירוג סיכון קודם (0-10):" ? (
                            <InputAdornment position="end">
                              <ReadOnlySlider
                                value={Number(fnccust?.SRII_BDIRISK2)}
                                valueLabelFormat={Number(
                                  fnccust?.SRII_BDIRISK2
                                )}
                              />
                            </InputAdornment>
                          ) : label === "דירוג סיכון (0-10):" ? (
                            <InputAdornment position="end">
                              <ReadOnlySlider
                                value={Number(fnccust?.SRII_BDIRISK)}
                                valueLabelFormat={Number(
                                  fnccust?.SRII_BDIRISK2
                                )}
                              />
                            </InputAdornment>
                          ) : null,
                      }}
                    />
                  </Box>
                ))}
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <div
              style={{
                marginBottom: "10px",
                marginLeft: "30%",
                marginRight: "5%",
              }}
            >
              <Typography
                style={{
                  // fontWeight: "bold",
                  fontSize: "1.1rem",
                  display: "inline-block",
                  marginBottom: "10px",
                  backgroundColor: "#f0f0f0",
                  padding: "5px",
                  paddingLeft: "4px",
                  paddingRight: "4px",
                  paddingBottom: "3px",
                  paddingTop: "3px",
                  borderRadius: "5px",
                  lineHeight: "1",
                }}
              >
                D&B
              </Typography>

              <div>
                {Object.entries(dnbFields).map(([label, value], index) => (
                  <Box key={index} mb={2}>
                    <TextField
                      label={label}
                      variant="standard"
                      value={value}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        readOnly: true,
                        endAdornment: label === "ציון סקור (0-100):" && (
                          <InputAdornment position="end">
                            {/* <CustomRatingSlider value={Number(fnccust?.MED_DNBSCORE)}/> */}
                            <ReadOnlySlider
                              value={
                                Math.round(Number(fnccust?.MED_DNBSCORE)) / 10
                              }
                              valueLabelFormat={Math.round(
                                Number(fnccust?.MED_DNBSCORE)
                              )}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                ))}
              </div>
            </div>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};
